module.exports = __webpack_public_path__ + "img/report.d2533aa8.svg";